export default __webpack_public_path__ + "static/media/bg.4debf033.png";